import React from 'react';
import noop from 'lodash/noop';
var NavContext = /*#__PURE__*/React.createContext({
  withinNav: false,
  activeKey: null,
  onSelect: noop
});
export default NavContext;